import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import href from '#utilities/js/ea/href.js'
import globals from '#utilities/js/ea/globals.js'
import confirm from '#utilities/js/ea/confirm.js'
import array from '@mailobj-browser/front/js/utils/array.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: async (
    element
  ) => {
    const postit = element.closest('div.ea_auth__postit')
    const { dataset } = postit
    const { uid, confirm: msg } = dataset

    const url = href('auth/postit', {
      delete: uid
    })

    const result = await confirm(msg, '', [element])

    if (result) {
      globals.ea_link(url, 'nodiv_in', null)
      remove(postit)
    }
  }
})

export default button => {
  onClick.listen(button)
}
